<ng-container *adaptLoading="!initialised">
    <div class="d-flex flex-column flex-1 flex-wrap w-100">
        <div class="d-flex flex-row align-items-center gap-2">
            @if (showIcon) {
                <i [class]="meeting.eventSeries?.eventType?.colour ? 'fas' : 'far'"
                   [ngClass]="iconClass"
                   [style.color]="meeting.eventSeries?.eventType?.colour"></i>
            }
            @if (linkDisabled) {
                @if (meetingUrl$ | async; as meetingUrl) {
                    <a [routerLink]="meetingUrl.path"
                       [queryParams]="meetingUrl.queryParams">
                        <h5 class="my-1">
                            @if (showTeamName) {
                                <span>{{ meeting.team?.name }}: </span>
                            }
                            {{ meeting.name }}
                        </h5>
                    </a>
                } @else {
                    <h5 class="text-wrap">{{ meeting.name }}</h5>
                }
            } @else {
                <h5 class="text-wrap">{{ meeting.name }}</h5>
            }
            @if (compact) {
                <div class="d-flex align-items-center ms-auto">
                    <ng-container [ngTemplateOutlet]="inProgressBadge"></ng-container>
                </div>
            }
        </div>
        @if ((meeting.extensions.hasPreWork || meeting.extensions.hasFacilitationNotes) && preWorkVisible) {
            <div class="pre-work-notice">
                @if (preWorkClickable) {
                    <button class="btn btn-link small"
                            (click)="showPreWork()">
                        {{ preWorkText }}
                    </button>
                } @else {
                    <span class="small">{{ preWorkText }}</span>
                }
            </div>
        }
        <div class="small"
             title="When this meeting will take place">
            <span>{{ meeting.meetingDateTime | adaptDate }}</span>
            <span class="mx-2">/</span>
            <span>{{ meeting.meetingDateTime | adaptTime }}</span>
            @if (meeting.endTime) {
                <span class="mx-1">-</span>
                <span>{{ meeting.endTime | adaptTime }}</span>
            }
        </div>
        @if (meeting.location) {
            <div class="small"
                 title="Where this meeting will take place">
                {{ meeting.location }}
            </div>
        }
    </div>

    @if (!compact) {
        <div class="align-self-center d-flex">
            @if (canStart) {
                <div>
                    @if (showStartButton) {
                        <button adaptButtonIcon="fal fa-fw fa-play-circle"
                                [adaptBlockingClick]="startMeeting"
                                class="btn btn-primary text-nowrap"
                                [unsubscribeOnDestroy]="false"
                                data-test="start-meeting-button">Start</button>
                    }
                </div>
            } @else {
                <ng-container [ngTemplateOutlet]="inProgressBadge"></ng-container>
            }
        </div>
    }
</ng-container>

<ng-template #inProgressBadge>
    @if (isInProgress && showStatus) {
        <span class="badge bg-danger">In progress</span>
    } @else if (nonStartableMeetingInfo && showInfoIcon) {
        <i class="ms-1 fal fa-info-circle"
           [adaptTooltip]="nonStartableMeetingInfo"></i>
    }
</ng-template>
